
<template>
    <div>
        <div class="adjust_editor" v-if="!is_land">
            <b-row class="mem_create_row" >
                <b-col offset-md="7" md="5"  xs="6" offset-xs="6" lg="5" offset-lg="7" xl="4" offset-xl="8">
                    
                    <button type="button" class="btn btn-lg btn-primary waves-effect waves-themed w-100 mt-5 mb-5"
                            @click="show_parts_modal"
                            v-if="is_parts">
                        <span class="fal  fa-eject mr-1"></span>
                        Редагувати запчастини
                    </button>
                    
                    <button type="button" class="btn btn-lg btn-primary waves-effect waves-themed w-100 mb-2 mt-2"
                            @click="show_adjust_editor">
                            <span class="fal  fa-eject mr-1"></span>
                            Редагувати погодження
                    </button>
                    
                    <button type="button" class="btn btn-lg btn-primary waves-effect waves-themed w-100"
                            @click="show_invoice_editor">
                            <span class="fal  fa-eject mr-1"></span>
                            Редагувати повідомлення
                    </button>
                    
                </b-col>
            </b-row>
        </div>
        
        <div class="adjust_editor" v-else-if="is_land && can_replace_last_adjust">
            <b-row class="mem_create_row" >
                <b-col offset-md="7" md="5"  xs="6" offset-xs="6" lg="5" offset-lg="7" xl="4" offset-xl="8">
                    <button type="button" class="btn btn-lg btn-primary waves-effect waves-themed w-100 mb-2 mt-2" @click="show_adjust_replacer">
                        <span class="fal  fa-eject mr-1"></span>
                        Заміна останнього погоджувача
                    </button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>



<script>

import {mapGetters} from "vuex";
export default {
    name: "work_users_block",
    
    data() {
        return {
        
        }
    },
    
    methods : {
        
        show_parts_modal() {
            EventBus.$emit('edit_parts');
        },
        
        show_adjust_editor () {
            EventBus.$emit('load_users_adjust',{
                doc_id: this.memorandum.id,
            });
        },
        
        show_invoice_editor () {
            EventBus.$emit('load_users_invoice',{
                doc_id: this.memorandum.id,
            });
        },
        
        show_adjust_replacer () {
            EventBus.$emit('load_users_replace',{
                doc_id: this.memorandum.id,
            });
        },
        
        show_vacation_editor () {
            EventBus.$emit('load_vacation_period',{
                doc_id: this.memorandum.id,
            });
        },
    },
    
    computed: {
        ...mapGetters({
            'memorandum': "memorandum_inside/getMemorandum",
            'is_mem_load': "memorandum_inside/is_load"
        }),
        
        
        can_replace_last_adjust() {
            if(this.memorandum.hasOwnProperty('can_replace_last_adjust')) {
                return this.memorandum.can_replace_last_adjust;
            }
            
            return false;
        },
        
        current_addon () {
            if(this.memorandum.hasOwnProperty("addon")) {
                return this.memorandum.addon;
            }
            
            return '';
        },
        
        
        is_land() {
            return this.current_addon === 'land';
        },
        
        is_parts() {
            return this.current_addon === 'parts' || this.current_addon === 'parts_reserv';
        },
        
        
    }
}
</script>


<style scoped>

</style>